export default function errorStyling(error: string | undefined): string {
  switch (error) {
    case 'NotAuthorizedException':
      return 'Email o password errate!';
    case 'UserNotConfirmedException':
      return 'La mail non è stata ancora confermata';
    case 'UsernameExistsException':
      return 'La mail risulta già registrata';
    case 'NotAuthorizedConfirm':
      return 'Si è verificato un problema con la conferma della mail. La mail potrebbe essere già confermata o non registrata';
    case 'LimitExceededException':
      return 'Limite di tentativi disponibili raggiunto, si prega di riprovare più tardi.';
    case 'CodeMismatchException':
      return 'Il codice non corrisponde a quello ricevuto nella mail!';
    case 'UserNotFoundException':
      return 'Non è stato trovato nessun profilo con questa mail, si prega di verificare i dati inseriti!';
    default:
      return '';
  }
}